import { render, staticRenderFns } from "./myCustomer.vue?vue&type=template&id=a8a170c0&scoped=true&"
import script from "./myCustomer.vue?vue&type=script&lang=js&"
export * from "./myCustomer.vue?vue&type=script&lang=js&"
import style0 from "./myCustomer.vue?vue&type=style&index=0&id=a8a170c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a170c0",
  null
  
)

export default component.exports